
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import style from './news.module.css'

import { getLayout } from '../components/sg/Layout'
import Header from '../components/Header'
import Loading from '../components/Loading'
import useTranslation from 'next-translate/useTranslation'
import classNames from 'classnames/bind'
import { useNews } from '../hooks/useNews'
import Banner from '../components/Banner'
import Footer from '../components/sg/Footer'
import PullToRefresh from '../components/PullToRefresh'
import Head from 'next/head'
import { useRouter } from 'next/router'

export default function News () {
  const { t } = useTranslation('main')
  const router = useRouter()
  const { locale } = router
  const c = classNames.bind(style)

  const { pages: news, isEmpty, isLoadingMore, loadMore, isReachingEnd, updateNews } = useNews(locale)
  return (
    <>
      <Head>
        <title>{t('news-title')}</title>
      </Head>
      <PullToRefresh onRefresh={() => { updateNews(undefined) }} isRefreshing={isLoadingMore} />
      <Header title={t('news-title')} />
      <Banner />
      {isLoadingMore && <section />}
      <div className={c('news', { loading: isLoadingMore })}>
        <section>
          <ul>
            {isEmpty ? <li className={c('empty')}>{t('news-empty')}</li> : news}
          </ul>
          {!isReachingEnd &&
            <button disabled={isLoadingMore} onClick={() => loadMore(news)} className='light'>
              {isLoadingMore ? <Loading /> : t('news-loadmore')}
            </button>}
        </section>
      </div>
      <Footer />
    </>
  )
}

News.getLayout = getLayout


    export async function getStaticProps(ctx) {
        
        
        return {
          
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/news',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  